(function () {
  'use strict';

  function chromeHeight() {
    var h = 0;
    var topBar = document.querySelector('.top-bar3');
    var header = document.querySelector('header.header1') || document.querySelector('.header1');
    if (topBar && getComputedStyle(topBar).display !== 'none') h += topBar.offsetHeight;
    if (header && getComputedStyle(header).display !== 'none') h += header.offsetHeight;
    return Math.round(h) || 0;
  }

  function scrollPerPhase(root) {
    var raw = getComputedStyle(root).getPropertyValue('--cp-scroll').trim();
    var viewH = window.innerHeight || document.documentElement.clientHeight;
    var value = parseFloat(raw) || 120;
    if (raw.indexOf('vh') !== -1) return (value / 100) * viewH;
    return value;
  }

  function reducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function isMobile() {
    return window.matchMedia('(max-width: 991px)').matches;
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function renderTimeline(el, raw) {
    if (!el) return;
    var meta = (raw || '').trim();
    if (!meta) {
      el.innerHTML = '';
      el.hidden = true;
      return;
    }

    el.hidden = false;

    var parts = [];
    var re = /(?:^|,)\s*([^:]+):\s*([^,]+)/g;
    var match;
    while ((match = re.exec(meta)) !== null) {
      parts.push({
        label: match[1].trim(),
        value: match[2].trim()
      });
    }

    if (parts.length) {
      el.innerHTML = parts
        .map(function (part) {
          return (
            '<span class="care-phases__timeline-chip">' +
              '<span class="care-phases__timeline-label">' + escapeHtml(part.label) + '</span>' +
              '<span class="care-phases__timeline-value">' + escapeHtml(part.value) + '</span>' +
            '</span>'
          );
        })
        .join('');
      return;
    }

    el.innerHTML =
      '<span class="care-phases__timeline-chip care-phases__timeline-chip--plain">' +
        '<span class="care-phases__timeline-value">' + escapeHtml(meta) + '</span>' +
      '</span>';
  }

  function init(root) {
    if (!root || root.dataset.cpReady === '1') return;
    root.dataset.cpReady = '1';

    var pin = root.querySelector('[data-cp-pin]');
    var tracks = Array.prototype.slice.call(root.querySelectorAll('[data-cp-track]'));
    var title = root.querySelector('[data-cp-title]');
    var titleWrap = root.querySelector('[data-cp-title-wrap]');
    var timeline = root.querySelector('[data-cp-timeline]');
    var stage = root.querySelector('[data-cp-stage]');
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-cp-panel]'));
    var layerPanels = Array.prototype.slice.call(root.querySelectorAll('[data-cp-panel-layers]'));
    var productSets = Array.prototype.slice.call(root.querySelectorAll('[data-cp-product-set]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-cp-dot]'));
    var captions = Array.prototype.slice.call(root.querySelectorAll('[data-cp-caption-item]'));
    var prevBtn = root.querySelector('[data-cp-prev]');
    var nextBtn = root.querySelector('[data-cp-next]');
    var skipBtn = root.querySelector('[data-cp-skip]');
    if (!pin || !tracks.length || !panels.length) return;

    var titleList = panels.map(function (panel, i) {
      return panel.getAttribute('data-title') || 'PHASE ' + (i + 1);
    });
    var timelineList = panels.map(function (panel) {
      return panel.getAttribute('data-timeline') || '';
    });
    var timelineAlignList = panels.map(function (panel) {
      return panel.getAttribute('data-timeline-align') === 'left' ? 'left' : 'right';
    });

    var count = panels.length;
    var index = 0;
    var locked = false;
    var ticking = false;
    var mx = 0;
    var my = 0;
    var tx = 0;
    var ty = 0;
    var rafParallax = 0;
    var fallDelayTimer = 0;
    var fallDoneTimer = 0;
    var SLIDE_MS = 500;
    var FALL_DELAY_MS = 400;
    var FALL_MS = 650;

    function layersFor(i) {
      return layerPanels.filter(function (panel) {
        return String(panel.getAttribute('data-index')) === String(i);
      });
    }

    function clearLayerAnimClasses() {
      layerPanels.forEach(function (panel) {
        panel.classList.remove(
          'is-waiting-next',
          'is-waiting-prev',
          'is-enter-next',
          'is-enter-prev'
        );
      });
    }

    function setChrome() {
      var chrome = chromeHeight();
      root.style.setProperty('--cp-chrome', chrome + 'px');
      root.style.setProperty('--cp-count', String(count));

      if (isMobile() || reducedMotion()) {
        pin.style.height = '';
        return;
      }

      var viewH = Math.max(1, Math.round(window.innerHeight || 0));
      var distance = scrollPerPhase(root) * Math.max(1, count);
      pin.style.height = Math.round(viewH + distance) + 'px';
    }

    function syncBackground(i) {
      var panel = panels[i];
      if (!panel) return;
      var bg = panel.getAttribute('data-bg');
      if (bg) {
        root.style.setProperty('--cp-bg', bg);
        root.style.background = bg;
        if (stage) stage.style.background = bg;
        if (pin) pin.style.background = bg;
      }
      var titleColor = panel.getAttribute('data-title-color');
      if (titleColor) {
        root.style.setProperty('--cp-title', titleColor);
      }
      var timelineColor = panel.getAttribute('data-timeline-color');
      if (timelineColor) {
        root.style.setProperty('--cp-timeline', timelineColor);
        if (timeline) timeline.style.setProperty('--cp-timeline', timelineColor);
      }
      if (timeline) {
        var align = panel.getAttribute('data-timeline-align') === 'left' ? 'left' : 'right';
        timeline.classList.remove('care-phases__timeline--left', 'care-phases__timeline--right');
        timeline.classList.add('care-phases__timeline--' + align);
      }
    }

    function slideTracks(i) {
      var offset = -(i * (100 / Math.max(1, count)));
      tracks.forEach(function (track) {
        track.style.transform = 'translate3d(' + offset + '%, 0, 0)';
      });
    }

    function paintChrome(i) {
      productSets.forEach(function (set, n) {
        set.classList.toggle('is-active', n === i);
      });

      dots.forEach(function (dot, n) {
        var on = n === i;
        dot.classList.toggle('is-active', on);
        dot.setAttribute('aria-selected', on ? 'true' : 'false');
      });

      captions.forEach(function (cap, n) {
        cap.classList.toggle('is-active', n === i);
      });

      if (prevBtn) {
        if (i <= 0) prevBtn.setAttribute('hidden', '');
        else prevBtn.removeAttribute('hidden');
      }
      if (nextBtn) {
        if (i >= count - 1) nextBtn.setAttribute('hidden', '');
        else nextBtn.removeAttribute('hidden');
      }
    }

    function fitTitle() {
      if (!title) return;
      if (isMobile() || window.innerWidth > 1440) {
        title.style.fontSize = '';
        return;
      }
      title.style.fontSize = '100px';
      var measured = title.scrollWidth;
      if (!measured) return;
      title.style.fontSize = ((100 * window.innerWidth * 0.9) / measured) + 'px';
    }

    function animateTitle(i) {
      if (!title) return;
      var animTarget = titleWrap || title;
      animTarget.classList.add('is-enter');
      window.setTimeout(function () {
        title.textContent = titleList[i] || 'PHASE ' + (i + 1);
        fitTitle();
        if (timeline) {
          renderTimeline(timeline, timelineList[i] || '');
          var align = timelineAlignList[i] || 'right';
          timeline.classList.remove('care-phases__timeline--left', 'care-phases__timeline--right');
          timeline.classList.add('care-phases__timeline--' + align);
        }
        animTarget.classList.remove('is-enter');
      }, 80);
    }

    /**
     * CodePen timing:
     * 1) Background slides horizontally (0.5s)
     * 2) After ~0.4s delay, ingredients fall from top (or bottom on prev)
     */
    function paintUI(i, opts) {
      opts = opts || {};
      var goingNext = opts.direction !== 'prev';
      var animate = opts.animate !== false;
      var skipFallDelay = opts.skipFallDelay === true;

      window.clearTimeout(fallDelayTimer);
      window.clearTimeout(fallDoneTimer);
      clearLayerAnimClasses();

      // Match section/stage fill to the incoming slide immediately so no
      // previous-phase strip can show at the top during/after the move.
      syncBackground(i);
      slideTracks(i);
      paintChrome(i);
      animateTitle(i);

      if (!animate || reducedMotion()) {
        return;
      }

      var incoming = layersFor(i);
      var waitClass = goingNext ? 'is-waiting-next' : 'is-waiting-prev';
      var enterClass = goingNext ? 'is-enter-next' : 'is-enter-prev';

      // Park ingredients off-screen while the color panel slides in
      incoming.forEach(function (panel) {
        panel.classList.add(waitClass);
      });

      var delay = skipFallDelay ? 80 : FALL_DELAY_MS;
      fallDelayTimer = window.setTimeout(function () {
        incoming.forEach(function (panel) {
          panel.classList.remove(waitClass);
          // Force reflow so the fall animation always restarts
          void panel.offsetWidth;
          panel.classList.add(enterClass);
        });

        fallDoneTimer = window.setTimeout(function () {
          incoming.forEach(function (panel) {
            panel.classList.remove(enterClass);
          });
        }, FALL_MS);
      }, delay);
    }

    function goTo(i) {
      i = Math.max(0, Math.min(count - 1, i));
      if (i === index) return;
      var direction = i > index ? 'next' : 'prev';
      index = i;
      paintUI(index, { direction: direction, animate: true });

      if (isMobile() || reducedMotion()) return;

      locked = true;
      var viewH = Math.max(1, (window.innerHeight || 0));
      var scrollable = Math.max(1, pin.offsetHeight - viewH);
      var targetProgress = (index + 0.5) / Math.max(1, count);
      var pinTop = pin.getBoundingClientRect().top + (window.pageYOffset || window.scrollY || 0);
      var y = pinTop + targetProgress * scrollable;
      window.scrollTo({ top: Math.max(0, y), behavior: 'auto' });
      window.setTimeout(function () {
        locked = false;
        wheelAccum = 0;
      }, SLIDE_MS + FALL_DELAY_MS);
    }

    var wheelAccum = 0;
    var WHEEL_THRESHOLD = 28;

    function sectionIsPinned() {
      var rect = pin.getBoundingClientRect();
      var viewH = Math.max(1, window.innerHeight || 0);
      var chrome = chromeHeight();
      return rect.top <= chrome + 2 && rect.bottom >= viewH - 2;
    }

    function onWheel(e) {
      if (isMobile() || reducedMotion()) return;
      if (!sectionIsPinned()) {
        wheelAccum = 0;
        return;
      }

      var delta = e.deltaY;
      // Allow the page to leave the section at the ends
      if (index <= 0 && delta < 0) {
        wheelAccum = 0;
        return;
      }
      if (index >= count - 1 && delta > 0) {
        wheelAccum = 0;
        return;
      }

      e.preventDefault();
      if (locked) return;

      wheelAccum += delta;
      if (Math.abs(wheelAccum) < WHEEL_THRESHOLD) return;

      var dir = wheelAccum > 0 ? 1 : -1;
      wheelAccum = 0;
      goTo(index + dir);
    }

    function onScroll() {
      if (ticking || locked) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        if (isMobile() || reducedMotion()) return;

        var rect = pin.getBoundingClientRect();
        var viewH = Math.max(1, (window.innerHeight || 0));
        var scrollable = Math.max(1, pin.offsetHeight - viewH);
        var fromPin = -rect.top;
        var progress = Math.min(1, Math.max(0, fromPin / scrollable));
        var next = Math.min(count - 1, Math.floor(progress * count));
        if (progress >= 0.999) next = count - 1;
        if (next !== index) {
          var direction = next > index ? 'next' : 'prev';
          index = next;
          paintUI(index, { direction: direction, animate: true });
        }
      });
    }

    function applyParallax() {
      rafParallax = 0;
      mx += (tx - mx) * 0.1;
      my += (ty - my) * 0.1;
      root.style.setProperty('--cp-mx', mx.toFixed(4));
      root.style.setProperty('--cp-my', my.toFixed(4));
      if (Math.abs(tx - mx) > 0.001 || Math.abs(ty - my) > 0.001) {
        rafParallax = requestAnimationFrame(applyParallax);
      }
    }

    function onPointer(e) {
      if (reducedMotion() || isMobile() || !stage) return;
      var rect = stage.getBoundingClientRect();
      tx = ((e.clientX - rect.left) / rect.width - 0.5) * 2;
      ty = ((e.clientY - rect.top) / rect.height - 0.5) * 2;
      if (!rafParallax) rafParallax = requestAnimationFrame(applyParallax);
    }

    function onLeave() {
      tx = 0;
      ty = 0;
      if (!rafParallax) rafParallax = requestAnimationFrame(applyParallax);
    }

    function skipToNextSection() {
      if (isMobile() || reducedMotion()) return;

      locked = true;
      wheelAccum = 0;
      index = count - 1;
      paintUI(index, { direction: 'next', animate: false, skipFallDelay: true });

      var pinTop = pin.getBoundingClientRect().top + (window.pageYOffset || window.scrollY || 0);
      var targetY = pinTop + pin.offsetHeight - 1;

      window.scrollTo({ top: Math.max(0, targetY), behavior: 'smooth' });
      window.setTimeout(function () {
        locked = false;
      }, 900);
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(index - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(index + 1); });
    if (skipBtn) skipBtn.addEventListener('click', skipToNextSection);
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goTo(parseInt(dot.getAttribute('data-index'), 10) || 0);
      });
    });

    if (stage) {
      stage.addEventListener('pointermove', onPointer, { passive: true });
      stage.addEventListener('pointerleave', onLeave, { passive: true });
    }

    setChrome();
    // Initial: match CodePen — ingredients fall from top after a short beat
    paintUI(0, { direction: 'next', animate: true, skipFallDelay: false });
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('wheel', onWheel, { passive: false });
    window.addEventListener('resize', function () {
      setChrome();
      fitTitle();
      onScroll();
    });
  }

  function boot() {
    document.querySelectorAll('[data-care-phases]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target && event.target.querySelector('[data-care-phases]');
    if (!root) return;
    root.dataset.cpReady = '0';
    init(root);
  });
})();
